import { createFileRoute, redirect } from '@tanstack/react-router'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'

// Redirector: /documents/projects/$projectId -> /org/$orgId/projects/$projectId
export const Route = createFileRoute(
  '/_authenticated/_dashboard/documents/projects/$projectId/',
)({
  component: () => null,
  beforeLoad: async ({ params }) => {
    const store = useSelectedTenantStore.getState()
    if (store.selectedTenantId) {
      throw redirect({
        to: '/org/$orgId/projects/$projectId',
        params: {
          orgId: store.selectedTenantId,
          projectId: params.projectId,
        },
        search: (prev) => prev,
      })
    }
    throw redirect({ to: '/select-tenant' })
  },
})
